export default "__VITE_ASSET__bOHJCOgY__"